import React, { useState, useEffect, useContext } from 'react';
import cn from 'classnames';
import { withStyles } from '@material-ui/styles';
import { OrderDetailContext } from '../OrderDetailContext';
import Button from '@material-ui/core/Button';

// SERVICES
import { getVexceliFrame, logout } from '../../../services';
import Loading from '../../Loading';

const styles = theme => ({});

const getImage = filename => require(`../../../assets/images/${filename}`);
const BV_LOGO = getImage('bv-logo.png');

export const OrderDetailVexceliFrameTab = withStyles(styles)(({ orderLineId, classes }) => {
  const { state, dispatch } = useContext(OrderDetailContext);

  // const [modalVisible, setModalVisible] = useState(false);
  // const [actionMode, setActionMode] = useState(null);
  const [repotrCodes, setReportCodes] = useState([]);
  const [iFrame, setiFrameLink] = useState(null);
  const [loadingIFrame, setLoadingIFrame] = useState(true);

  useEffect(() => {
    const getVexceliFrameAsync = async () => {
      try {
        setLoadingIFrame(true);
        const link = await getVexceliFrame(orderLineId);
        setiFrameLink(link);
      } catch (error) {
        console.log('Vexcel iFrame error', error);
      } finally {
        setLoadingIFrame(false);
      }
    };

    getVexceliFrameAsync();
  }, []);

  if (loadingIFrame)
    return (
      <div className={cn('flex-1', 'col-center-center')}>
        <Loading />
      </div>
    );

    console.log({iFrame})

  return (
    <div className={cn('flex-1', 'col-center-center')}>
      {!!iFrame ? (
        <React.Fragment>
          <Button
            variant="contained"
            color="primary"
            onClick={() => window.open(iFrame, '_blank')}
          >
            Open Vexcel Viewer
          </Button>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <span>This order has no Vexcel Data</span>
        </React.Fragment>
      )}
    </div>
  );
});

OrderDetailVexceliFrameTab.propTypes = {};

OrderDetailVexceliFrameTab.defaultProps = {};
